import {call, put, takeEvery} from 'redux-saga/effects'
import Api from "../services/Api";


function* fetchSafesPlanning(action) {
  try {
    const safesPlanning = yield call(function() {
      return Api.get('/dealer/safe/planning', action.params);
    });
    yield put({type: 'FETCH_SAFES_PLANNING.SUCCESS', safesPlanning})
  } catch (error) {
    yield put({type: 'FETCH_SAFES_PLANNING.FAILURE', error})
  }
}

export function* watchFetchSafesPlanning() {
  yield takeEvery('FETCH_SAFES_PLANNING.REQUEST', fetchSafesPlanning);
}


function* fetchInterventionSafesPlanning(action) {
  const {id, params} = action;
  try {
    const safes = yield call(function() {
      return Api.get(`/intervention/${id}/safes-planning`, params);
    });
    yield put({type: 'FETCH_INTERVENTION_SAFES_PLANNING.SUCCESS', safes})
  } catch (error) {
    yield put({type: 'FETCH_INTERVENTION_SAFES_PLANNING.FAILURE', error})
  }
}

export function* watchFetchInterventionSafesPlanning() {
  yield takeEvery('FETCH_INTERVENTION_SAFES_PLANNING.REQUEST', fetchInterventionSafesPlanning);
}



// WEBPACK FOOTER //
// ./src/sagas/safesPlanning.js